import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { CommonHttpService } from '../common-http.service';
import { environment } from '../../../environments/environment';
import { IFavoriteItem } from '../../models/IFavoriteItem';

@Injectable({
  providedIn: 'root'
})
export class FavoritesItemsService {

  private httpService = inject(CommonHttpService);
  private http = inject(HttpClient);
  private oidcSecurityService = inject(OidcSecurityService);

  favoriteItemSignal = signal<any | null>(null);
  itemFavoriteSignal = signal<IFavoriteItem[]>([]);
  isLoading = signal(true);

  constructor() { }

  putFavorite(itemId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/favorites/${itemId}`;
    // const url = `https://qanew.biddingforgood.com/v3/favorites/${itemId}`;

    // console.log('url', url)

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.httpService.put<string>(url, null, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {
        // console.log('favorite item response:', response);
        this.favoriteItemSignal.set(response);
      })
    );
  }

  deleteFavorite(itemId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/favorites/${itemId}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');
          return this.httpService.delete<string>(url, null, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {
        this.favoriteItemSignal.set(response);
      })
    );
  }

  getFavorites(): Observable<any> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/favorites`;


    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<any>(url, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {
        console.log(response, 'Favorites')
        this.itemFavoriteSignal.set(response)
        this.isLoading.set(false);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    )
  }

  putEmailAddress(itemId: number, value: boolean): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/favorites/${itemId}/email-alerts`;
    const body = `shouldReceive=${value}`

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.httpService.put<string>(url, body, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      })
    );
  }
}
